import React, { useState, useEffect } from 'react';
import { Box, IconButton, Card, CardContent, Typography, Stack } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useSwipeable } from 'react-swipeable';


const Carousel = ({ elements, elementsPerPage, useTimer, hideArrowsMobile, spaceBetween,  hideArrowsDesktop, timerValue}) => {

    const [width, setWidth] = useState(window.innerWidth)
    const [currentPage, setCurrentPage] = useState(0);
    const [cardsPerPage, setCardsPerPage] = useState(Math.min(elementsPerPage, elements.length));
    const [showArrows, setShowArrows] = useState(true);

    const totalPages = Math.ceil(elements.length / cardsPerPage);

    const handleNextPage = () => {
        setCurrentPage((prev) => (prev + 1) % totalPages); // Loop back to the first page
    };

    const handlePrevPage = () => {
        setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages); // Loop to the last page
    };


    const handlers = useSwipeable({
        onSwipedLeft: handleNextPage,
        onSwipedRight: handlePrevPage,
        preventDefaultTouchmoveEvent: false,
        trackMouse: true
    });

    useEffect(() => {
        const updateCardsPerPage = () => setWidth(window.innerWidth)
        if (width < 600) {
            setCardsPerPage(1)
            setShowArrows(!Boolean(hideArrowsMobile))
        }
        else if (width < 900) {
            setCardsPerPage(2)
        }
        else {
            setShowArrows(!Boolean(hideArrowsDesktop))
        }
        window.addEventListener("resize", updateCardsPerPage);

            const timer = (useTimer) ? setInterval(() => {
                handleNextPage()
            }, timerValue || 6000) : null

        return () => {
            if (useTimer) { clearInterval(timer) }
            window.removeEventListener("resize", updateCardsPerPage);
        }
    }, []);



    const startIndex = currentPage * cardsPerPage;
    const displayedCards = startIndex + cardsPerPage < elements.length ?
        elements.slice(startIndex, startIndex + cardsPerPage) :
        elements.slice(startIndex, elements.length).concat(elements.slice(0, startIndex + cardsPerPage - elements.length));

    // console.log(cardsPerPage)

    return (
        <Box {...handlers} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '400px', position: 'relative'}}>
            {showArrows && (
                <IconButton onClick={handlePrevPage}>
                    <NavigateBeforeIcon />
                </IconButton>
            )}
            <Stack direction="row" spacing={spaceBetween} className="carousel-content">
                {displayedCards}
            </Stack>
            {showArrows && (
                <IconButton onClick={handleNextPage}>
                    <NavigateNextIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default Carousel